import axios from "axios"

export default{
    async SubeList(){
        const response = await axios.get(`/api/netsis/sube/list/`)
        return response
    },
    async HesapList(isyeri){
        const response = await axios.get(`/api/netsis/hesap/list/${isyeri}`)
        return response
    },
    async HesapListAll(){
        const response = await axios.get(`/api/netsis/hesap/list`)
        return response
    },
    async SGKDurum(){
        const response = await axios.get(`/api/netsis/list/sgkdurum`)
        return response
    },
    async SGKBTuru(){
        const response = await axios.get(`/api/netsis/list/sgkbturu`)
        return response
    },
    async FiiliHizmetSBTM(){
        const response = await axios.get(`/api/netsis/list/fiilihizmetsbtm`)
        return response
    },
    async CheckCurrentTarih(){
        const response = await axios.get(`/api/netsis/checkcurrenttarih`)
        return response
    },
    async KYKMList(){
        const response = await axios.post(`/api/hroperations/kykm/list`)
        return response
    },
    async KYKMListByCode(code){
        const response = await axios.post(`/api/hroperations/kykm/list/${code}`)
        return response
    },
    async EksikGun(){
        const response = await axios.get(`/api/netsis/list/eksikgun`)
        return response
    },
    async GirCikKontrol(eId){
        const response = await axios.get(`/api/netsis/gircik/kontrol/${eId}`)
        return response
    },
    async GirCikIptal(eId){
        const response = await axios.get(`/api/netsis/gircik/iptal/${eId}`)
        return response
    },
    async GirCikTarihBildir(eId,date){
        const response = await axios.get(`/api/netsis/gircik/tarihbildir/${eId}/${date}`)
        return response
    },
}